import React from "react";

export const host = 'https://choven.lukas.ua'
// export const host = 'http://0.0.0.0:3001'
export const api = '/api_web'
export const avatar_url = 'https://api.multiavatar.com/'
export const rest_v = '/v1'

export const url = host + api
export const db_url = url + rest_v

// export const db_url = 'http://10.1.1.82:3001/api/v1'
// export const db_url_auth = 'http://10.1.1.82:3001/api'


/* LOGIN */
export const url_auth_login = url + '/auth/login';
export const url_auth_logout = url + '/auth/logout';
export const url_auth_info = url + '/auth/info';
export const db_url_forgot_password = url + '/auth/forgot-password'



/* SALE */
export const url_sales = db_url + '/document/sales';
export const url_sale = db_url + '/document/sale/';

/* REMAIN */
export const url_remains = db_url + '/document/availability';
export const url_remain = db_url + '/document/remain/';


/* DICTIONARY */
// Geography
export const url_a_geography = db_url + '/dictionary/a-geography';
export const url_active_geography = db_url + '/dictionary/geography/active';
export const url_geography = db_url + '/dictionary/geography/';
export const url_geography_name = db_url + '/dictionary/geography/name/';
export const url_geography_status = db_url + '/dictionary/geography/status';
export const url_geography_depend = db_url + '/dictionary/geography/depend/';

// Distributors
export const url_distributors = db_url + '/dictionary/distributors/';
export const url_active_distributors = db_url + '/dictionary/distributors/active/';
export const url_distributor = db_url + '/dictionary/distributor/';
export const url_distributor_status = db_url + '/dictionary/distributor/status';
export const url_distributor_depend = db_url + '/dictionary/distributor/depend/';

// Branches
export const url_branches = db_url + '/dictionary/branches/';
export const url_active_branches = db_url + '/dictionary/branches/active/';
export const url_branch = db_url + '/dictionary/branch/';
export const url_branch_status = db_url + '/dictionary/branch/status';
export const url_branch_depend = db_url + '/dictionary/branch/depend/';
export const url_branch_token = db_url + '/dictionary/branch/token';

// Warehouses
export const url_warehouses = db_url + '/dictionary/warehouses/';
export const url_active_warehouses = db_url + '/dictionary/warehouses/active/';
export const url_warehouse = db_url + '/dictionary/warehouse/';
export const url_warehouse_status = db_url + '/dictionary/warehouse/status';
export const url_warehouse_depend = db_url + '/dictionary/warehouse/depend/';
export const url_warehouse_filter = db_url + '/dictionary/warehouse/filter';


//Product Group
export const url_products_groups = db_url + '/dictionary/products-groups/';
export const url_active_products_groups = db_url + '/dictionary/products-groups/active/';
export const url_products_group = db_url + '/dictionary/products-group/';
export const url_products_group_status = db_url + '/dictionary/products-group/status';
export const url_products_group_depend = db_url + '/dictionary/products-group/depend/';

//Product Category
export const url_products_categories = db_url + '/dictionary/products-categories/';
export const url_active_products_categories = db_url + '/dictionary/products-categories/active/';
export const url_products_category = db_url + '/dictionary/products-category/';
export const url_products_category_status = db_url + '/dictionary/products-category/status';
export const url_products_category_depend = db_url + '/dictionary/products-category/depend/';

// Product
export const url_products = db_url + '/dictionary/products/';
export const url_product = db_url + '/dictionary/product/';
export const url_product_status = db_url + '/dictionary/product/status';
export const url_product_vendor_code = db_url + '/dictionary/product/vendor_code/';

export const url_vendor_code = db_url + '/dictionary/vendor_code/';

//OrgStructure
export const url_org_structures = db_url + '/dictionary/org_structures/';
export const url_org_structure = db_url + '/dictionary/org_structure/';
export const url_org_structure_status = db_url + '/dictionary/org_structure/status';
export const url_org_structure_parent = db_url + '/dictionary/org_structure/parent';
export const url_org_structure_filter = db_url + '/dictionary/org_structure/filter';
export const url_org_structure_branches = db_url + '/dictionary/org_structure/branches';

//OrgStructure Types
export const url_org_structure_types = db_url + '/dictionary/org_structure/types';
export const url_org_structure_type = db_url + '/dictionary/org_structure/type/';
export const url_org_structure_type_status = db_url + '/dictionary/org_structure/type/status';



//TradePoint
// export const url_trade_points = db_url + '/dictionary/trade_points/';
export const url_trade_point = db_url + '/dictionary/trade_point/';
export const url_trade_point_org_structure = db_url + '/dictionary/trade_points/org_structure';
export const url_trade_point_filter = db_url + '/dictionary/trade_point/filter';

//TradePoint Type
export const url_trade_point_types = db_url + '/dictionary/trade-point/types/';
export const url_active_trade_point_types = db_url + '/dictionary/trade-point/types/active/';
export const url_trade_point_type = db_url + '/dictionary/trade-point/type/';
export const url_trade_point_type_status = db_url + '/dictionary/trade-point/type/status';
export const url_trade_point_type_depend = db_url + '/dictionary/trade-point/type/depend/';

//TradePoint Category
export const url_trade_point_categories = db_url + '/dictionary/trade-point/categories/';
export const url_active_trade_point_categories = db_url + '/dictionary/trade-point/categories/active/';
export const url_trade_point_category = db_url + '/dictionary/trade-point/category/';
export const url_trade_point_category_status = db_url + '/dictionary/trade-point/category/status';
export const url_trade_point_category_depend = db_url + '/dictionary/trade-point/category/depend/';

//Chain
export const url_chains = db_url + '/dictionary/trade-point/chains/';
export const url_active_chains = db_url + '/dictionary/trade-point/chains/active/';
export const url_chain = db_url + '/dictionary/trade-point/chain/';
export const url_chain_status = db_url + '/dictionary/trade-point/chain/status';
export const url_chain_depend = db_url + '/dictionary/trade-point/chain/depend/';

//Route
export const url_routes = db_url + '/dictionary/trade-point/routes/';
export const url_active_routes = db_url + '/dictionary/trade-point/routes/active/';
export const url_route = db_url + '/dictionary/trade-point/route/';
export const url_route_status = db_url + '/dictionary/trade-point/route/status';
export const url_route_depend = db_url + '/dictionary/trade-point/route/depend/';

/* Document Setting */
//Type Reporting Period
export const url_reporting_period_types = db_url + '/dictionary/reporting-period/types';
export const url_reporting_period_type = db_url + '/dictionary/reporting-period/type/';
export const url_reporting_period_type_status = db_url + '/dictionary/reporting-period/type/status';

//Reporting Period
export const url_reporting_periods = db_url + '/dictionary/reporting-periods';
export const url_reporting_period = db_url + '/dictionary/reporting-period/';
export const url_reporting_period_status = db_url + '/dictionary/reporting-period/status';
export const url_reporting_period_add_branch = db_url + '/dictionary/reporting-period/add-branches';
export const url_reporting_period_delete_branch = db_url + '/dictionary/reporting-period/delete-branch';
export const url_reporting_period_delete = db_url + '/dictionary/reporting-period/delete';

//Pattern Activity
export const url_pattern_activities = db_url + '/dictionary/pattern-activities';
export const url_pattern_activity = db_url + '/dictionary/pattern-activity/';
export const url_pattern_activity_status = db_url + '/dictionary/pattern-activity/status';
export const url_pattern_activities_active = db_url + '/dictionary/pattern-activities/active';

//Documents Type
export const url_doc_types = db_url + '/dictionary/doc-types';
export const url_doc_type = db_url + '/dictionary/doc-type/';

//Unit
export const url_units = db_url + '/dictionary/units';
export const url_active_unit = db_url + '/dictionary/units/active';
export const url_unit = db_url + '/dictionary/unit/';
export const url_unit_status = db_url + '/dictionary/unit/status';
export const url_unit_depend = db_url + '/dictionary/unit/depend/';

/* Administrations */
// Users
export const url_users = db_url + '/admin/users';
export const url_user = db_url + '/admin/user/';
export const url_user_self = db_url + '/admin/user/self';
export const url_user_lang = db_url + '/admin/user/';
export const url_users_role = db_url + '/admin/users-role';
export const url_user_email = db_url + '/admin/user/email';
export const url_user_status = db_url + '/admin/user/status';
export const url_user_avatar = db_url + '/admin/user/avatar'

/* Development */
// Log
export const url_logs = db_url + '/development/logs';
export const url_log = db_url + '/development/log/';
export const url_default = db_url + '/development/default/';